const Setting = () => import(/* webpackPrefetch: true */ '@/views/private/setting/Index.vue')
const Member = () => import(/* webpackPrefetch: true */ '@/components/setting/Member.vue')
const Facility = () => import(/* webpackPrefetch: true */ '@/components/setting/Facility.vue')
const Bank = () => import(/* webpackPrefetch: true */ '@/components/setting/Bank.vue')
const Document = () => import(/* webpackPrefetch: true */ '@/components/setting/Document.vue')
const DP = () => import(/* webpackPrefetch: true */ '@/components/setting/DP.vue')
const SPKPR = () => import(/* webpackPrefetch: true */ '@/components/setting/SPKPR.vue')
const Signature = () => import(/* webpackPrefetch: true */ '@/components/setting/Signature.vue')

const routes = [
  {
    path: "/setting",
    name: "setting",
    component: Setting,
    meta: {
      title: "Pengaturan"
    },
    children: [
      {
        path: '/setting/member',
        name: 'setting member',
        component: Member,
        meta: {
          title: "Pengaturan Pengguna"
        }
      },
      {
        path: '/setting/facility',
        name: 'setting facility',
        component: Facility,
        meta: {
          title: "Pengaturan Fasilitas"
        }
      },
      {
        path: '/setting/bank',
        name: 'setting bank',
        component: Bank,
        meta: {
          title: "Pengaturan Bank"
        }
      },
      {
        path: '/setting/document',
        name: 'setting document',
        component: Document,
        meta: {
          title: "Pengaturan Dokumen"
        }
      },
      {
        path: '/setting/dp',
        name: 'setting dp',
        component: DP,
        meta: {
          title: "Pengaturan DP"
        }
      },
      {
        path: '/setting/spkpr',
        name: 'setting spkpr',
        component: SPKPR,
        meta: {
          title: "Pengaturan SPKPR"
        }
      },
      {
        path: '/setting/signature',
        name: 'setting signature',
        component: Signature,
        meta: {
          title: "Pengaturan TTD"
        }
      }
    ]
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})